export enum ProgramCategory {
  CORE = 'CORE',
  SPECIALTY = 'SPECIALTY',
  OPTION = 'OPTION',
  COMPLEMENT = 'COMPLEMENT',
}
